import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Formik } from 'formik';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { FREQUENCIES } from '../../../data/PredictionManager';
import generateNumbersPowerOfX from '../../../data/utilities/generateNumbersPowerOfX';
import Label from '../../elements/Label';
import FormikInput from '../../elements/formik/FormikInput';
import FormikSelect from '../../elements/formik/FormikSelect';
import { PreferencesContainer } from '../extra/preferences/PreferencesContainer';
const SIMULATION_NUMBER_OF_POINTS = generateNumbersPowerOfX(12, 19);
const selectStyles = {
    width: '100%',
    minWidth: '50px',
    maxWidth: '280px',
    height: 30,
    margin: 0,
};
const labelStyle = {
    label: { flex: 3, fontWeight: '500' },
    wrapper: { flex: 9, display: 'flex', alignItems: 'center' },
    container: { padding: '5px' },
};
const inputStyle = {
    input: {
        padding: '5px',
    },
};
function SpectrumSimulationPreferences({ options, onSave }, ref) {
    const formRef = useRef(null);
    useImperativeHandle(ref, () => ({
        saveSetting: () => {
            void formRef.current?.submitForm();
        },
    }), []);
    return (_jsx(PreferencesContainer, { style: { backgroundColor: 'white' }, children: _jsx(Formik, { initialValues: options, onSubmit: onSave, innerRef: formRef, children: _jsxs(_Fragment, { children: [_jsx(Label, { title: "Frequency", style: labelStyle, children: _jsx(FormikSelect, { items: FREQUENCIES, style: selectStyles, name: "options.frequency" }) }), _jsx(Label, { title: "Number of points", style: labelStyle, children: _jsx(FormikSelect, { items: SIMULATION_NUMBER_OF_POINTS, name: "options.nbPoints", style: selectStyles }) }), _jsxs(Label, { title: "Range", style: labelStyle, children: [_jsx(Label, { title: "From", children: _jsx(FormikInput, { name: "options.from", type: "number", style: inputStyle }) }), _jsx(Label, { title: "To", style: { label: { padding: '0 10px' } }, children: _jsx(FormikInput, { name: "options.to", type: "number", style: inputStyle }) })] }), _jsxs(Label, { title: "Line width", style: labelStyle, children: [_jsx(FormikInput, { name: "options.lineWidth", type: "number", style: inputStyle }), _jsx("span", { style: { paddingLeft: '0.4rem' }, children: " Hz " })] })] }) }) }));
}
export default forwardRef(SpectrumSimulationPreferences);
